export default "__VITE_ASSET__BPk8N9b8__"